// extracted by mini-css-extract-plugin
module.exports = {"guestsIndicator":"GuestsIndicator-module--guestsIndicator--3567c8","text":"GuestsIndicator-module--text--8c0907"};